import React from 'react'

const ViewPaymentReceiptList = () => {
  return (
    <div>ViewPaymentReceiptList</div>
  )
}

export default ViewPaymentReceiptList